<div class="utr-modal-wrapper">
    <div class="utr-modal-header">
        <h3 class="utr-modal-header-text">
            {{ success ? 'Export Request Received' : 'Export in Progress...' }}
        </h3>
        <mat-icon class="utr-modal-close-icon" (click)="close()"
            >close</mat-icon
        >
    </div>
    <mat-dialog-content>
        <ng-container *ngIf="success">
            <span class="export-message">
                Your request to download Payment Summary detail list is being
                processed. Once processed export option will be enabled.
                <br /><br />
                We will shortly send you a mail with a link to download your
                files.
            </span>
            <span class="export-message">
                Note: Download link will be active for 48h.
            </span>
        </ng-container>
        <ng-container *ngIf="!success">
            <span class="export-message">
                Your previous request to download Order detail list is being
                processed. Once processed, export option will be enabled.
            </span>
            <span class="export-message">
                We will shortly send you a mail with a link to download your
                files.
            </span>
            <span class="export-message">
                Note: Download link will be active for 48h.
            </span>
        </ng-container>
    </mat-dialog-content>
</div>
